import { useDropzone } from 'react-dropzone';
import { useCallback } from 'react';
import { Box, Card, Paper, Stack, Typography, alpha } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import GetTheme from '../helpers/theme';

const DropArea = ({fileHandler, label=null, compact=false, children}) => {
    const onDrop = useCallback((files) => {
        fileHandler(files);
    });
    const theme = GetTheme();
    const buttonColor = alpha(theme.palette.primary.main, 0.5);
    const buttonTextColor = theme.palette.primary.main;

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    if (compact) {
        return <Box {...getRootProps()} sx={{backgroundColor: 'unset', minHeight: 24, textAlign: "center", verticalAlign: "center", alignItems: "center"}}>
            <Stack direction="row" justifyContent={"center"} sx={{textAlign: "center", verticalAlign: "center", alignItems: "center", padding: 0}}>
            <input {...getInputProps()} />
            {children}
            {label && <Typography sx={{marginLeft: 1}} variant="button" color={buttonTextColor}>{label}</Typography>}
            </Stack>
        </Box>;
    }

    return <Card variant="outlined" {...getRootProps()} sx={{borderColor: buttonColor, minWidth: 100, minHeight: 38, textAlign: "center", verticalAlign: "center", alignItems: "center"}}>
                <Stack direction="row" justifyContent={"center"} sx={{textAlign: "center", verticalAlign: "center", alignItems: "center", padding: 1}}>
                <input {...getInputProps()} />
                <CloudUploadIcon />
                {label && <Typography sx={{marginLeft: 1}} variant="button" color={buttonTextColor}>{label}</Typography>}
                </Stack>
        </Card>
}

export default DropArea;
